module.exports = __webpack_public_path__ + "media/images/emblems/Roethenbach_im_Emmental-coat_of_arms-8deaa145ae398b229cf4aa681217ccb9.svg";